// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as MarkdownNumberedListExtended } from '../../../assets/icons/extended/markdown/markdown-numbered-list.svg?react';
import { createIcons } from '../../Icon';
const MarkdownNumberedListIcon = /* @__PURE__ */ createIcons('MarkdownNumberedList', {
    extended: MarkdownNumberedListExtended
});
MarkdownNumberedListIcon.supportedTypes = ['extended'];
MarkdownNumberedListIcon.category = 'markdown';
export default MarkdownNumberedListIcon;
